import { api } from "../api";
import { backendErrors } from "@/forms/service/common";
import { SIGNUP_STEPS } from "@/forms/service/auth";

export const mactraderSubmit = async (data: any) => {
  const { data: userData } = await api.forms.macTrader(data);

  if (!userData.success) {
    throw { errors: backendErrors(userData.errors || {}) };
  }
  return {
    next: SIGNUP_STEPS.THANK_YOU_STEP,
    data: userData
  };
};

export const mactraderJwtSubmit = async (data: any) => {
  const { data: userData } = await api.forms.macTraderJwt(data);

  if (!userData.success) {
    throw new Error("Session not found!");
  }
  return {
    next: SIGNUP_STEPS.THANK_YOU_STEP
  };
};
